export default function MultipleCardLoader({loadingCount, ...props}) {
    return (
        Array(loadingCount).fill(loadingCount).map((el,k) => 
            props.children
        )
    )
}
